// extracted by mini-css-extract-plugin
export default {"container":"qo-z","ratingLayout":"ro-z","ratingLabel":"so-z","nonInteractiveRatingLabel":"to-z"};